import { Select } from 'antd';
import { useMemo } from 'react';
import { IReportsPanel } from '../../../types/reports';
import AnalyticsLayout from '../Analytics/components/Layout/AnalyticsLayout';
import ReportsOnDemand from './components/metocean/ReportsOnDemand';
import ReportsPreprocessed from './components/preprocessed/ReportsPreprocessed';
import ReportsNavigation from './components/ReportsNavigation';
import {
  filterDefaultReportDatasets,
  filterSelectableReportDatasets,
} from './helpers/reportDatasetFilters';
import { useReportsNavigation } from './hooks/useReportsNavigation';
import styles from './Reports.module.scss';

export default function ReportsPanel(props: IReportsPanel) {
  const {
    datasets,
    coordinates,
    point,
    handleChangePoint,
    pointOption,
    setDatasetIsOfflineWarningVisible,
  } = props;

  const { activeReport, availableReports, handleReportTypeChanged } = useReportsNavigation();

  const shouldFilterSelectableDatasets = activeReport === 'metocean-conditions';

  const selectableDatasets = useMemo(
    () => (shouldFilterSelectableDatasets ? filterSelectableReportDatasets(datasets) : datasets),
    [datasets, shouldFilterSelectableDatasets]
  );

  const defaultDataset = useMemo(() => {
    const rawDefaults =
      point?.downloadPage?.map((item) => ({
        key: item.radioKey,
        value: item.datasetId,
      })) ?? [];
    return filterDefaultReportDatasets(rawDefaults, selectableDatasets);
  }, [point?.downloadPage, selectableDatasets]);

  return (
    <div className={styles.reports}>
      <AnalyticsLayout
        globalContent={
          <div className={styles.globalContentWrapper}>
            <div className={styles.pointLabel}>
              <span>Point</span>
            </div>
            <Select
              id="ReportsPanel-Select_point"
              className={styles.pointSelect}
              placeholder="Select point"
              onChange={handleChangePoint}
              options={pointOption}
              value={point}
              disabled={false}
            />
          </div>
        }
        removeTopSectionBorder
        navigationContent={
          <ReportsNavigation
            availableReports={availableReports}
            activeReport={activeReport}
            handleReportTypeChanged={handleReportTypeChanged}
          />
        }
      >
        {activeReport === 'metocean-conditions' && (
          <ReportsOnDemand
            datasets={selectableDatasets}
            defaultDataset={defaultDataset}
            point={point}
            setDatasetIsOfflineWarningVisible={setDatasetIsOfflineWarningVisible}
          />
        )}
        {activeReport === 'preprocessed-data' && (
          <ReportsPreprocessed
            defaultDataset={defaultDataset}
            coordinates={coordinates}
            datasets={selectableDatasets}
            setDatasetIsOfflineWarningVisible={setDatasetIsOfflineWarningVisible}
          />
        )}
      </AnalyticsLayout>
    </div>
  );
}
